// Generated by ReScript, PLEASE EDIT WITH CARE


function getData(coupon_code, placeOrderData, vehicle_ids, selected_vehicle_id) {
  var customerInfo = placeOrderData.customerInfo;
  var dropAddress = placeOrderData.dropAddress;
  var pickupAddress = placeOrderData.pickupAddress;
  var geo = placeOrderData.geo_region;
  var latLng = pickupAddress.latLng;
  var latLng$1 = pickupAddress.latLng;
  var latLng$2 = dropAddress.latLng;
  var latLng$3 = dropAddress.latLng;
  return {
          mobile: customerInfo.mobile,
          coupon_code: coupon_code,
          vehicle_id: selected_vehicle_id,
          quotations_request: {
            mobile: customerInfo.mobile,
            n_waypoints: 0,
            vehicle_ids: vehicle_ids,
            order: {
              customer_mobile: customerInfo.mobile,
              geo_region_id: geo !== undefined ? geo.id : -1,
              from_address_lat: latLng !== undefined ? latLng.lat : 0.0,
              from_address_long: latLng$1 !== undefined ? latLng$1.lng : 0.0,
              to_address_lat: latLng$2 !== undefined ? latLng$2.lat : 0.0,
              to_address_long: latLng$3 !== undefined ? latLng$3.lng : 0.0,
              waypoints_attributes: [],
              value_added_services: [],
              payment_mode: "cash",
              business_order_info: undefined,
              use_porter_credits: false
            },
            service_type: undefined
          }
        };
}

export {
  getData ,
  
}
/* No side effect */
